import(/* webpackMode: "eager" */ "/vercel/path0/apps/meater/app/[locale]/template.tsx");
